(() => {
    'use strict';

    howspace.widgets.sharedcontent = {
        initView: widget => {
            howspace.components.translator.init(widget);
            howspace.transcript.init(widget);
        },
        destroyView: widget => {
            howspace.transcript.destroy(widget);
        },
        initEdit: widget => {
            // Use buttons.
            widget.on('click', '.use-btn', e => {
                const btn = $(e.currentTarget);
                const card = btn.closest('.card');
                const sharedContentId = card.data('shared-content-id');
                const dataPayload = {
                    customer_shared_content: sharedContentId
                };
                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    showErrorNotification: () => true,
                    success: () => {
                        howspace.widgets.updateWidget(widget, 'view');
                    },
                });
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        }
    };
})();
